import {
  TranscriptSyncManager,
  type TranscriptSyncManagerArgs,
} from './TranscriptSyncManager.ts';

/** Registry of active transcript sync managers, keyed by meeting ID */
const managers = new Map<string, TranscriptSyncManager>();

/**
 * Get an existing manager or create a new one for the meeting.
 */
export function getOrCreateManager(
  args: TranscriptSyncManagerArgs
): TranscriptSyncManager {
  let manager = managers.get(args.meetingId);
  if (!manager) {
    manager = new TranscriptSyncManager(args);
    managers.set(args.meetingId, manager);
  }
  return manager;
}

/** Remove a manager from the registry, allowing it to be GC'd. */
export function removeManager(meetingId: string): void {
  managers.delete(meetingId);
}
